// function to know if the window object is available. this way we can notice if we're in the browser or in the server
export const isWindowObjectAvailable = () => {
  return typeof window !== 'undefined';
};
